import '~/../node_modules/normalize.css/normalize.css'
import '~/../node_modules/react-router-modal/css/react-router-modal.css'
import './stylesheets/index.styl'
// import '@mdi/font/css/materialdesignicons.css'

import 'leaflet/dist/leaflet.css'
import L from 'leaflet';
// CSS fix
// L.Icon.Default.imagePath = '.';
// OR
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});
